import axios from "axios";
import { baseUrl } from "./baseUrl";

const api = axios.create({
    baseURL: `${baseUrl}/admin/campaign`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// Brand CRUD API
export const createBrand = async (data) => {
    try {
        const res = await api.post("/create-brand", data);
        return res.data;
    } catch (error) {
        console.error("Error creating brand:", error);
        throw error;
    }
};

export const getBrands = async () => {
    try {
        const res = await api.get("/get-all-brands");
        return res.data;
    } catch (error) {
        console.error("Error fetching brands:", error);
        throw error;
    }
};

export const getBrandById = async (id) => {
    try {
        const res = await api.get(`/get-brand/${id}`);
        return res.data;
    } catch (error) {
        console.error("Error fetching brand:", error);
        throw error;
    }
};

export const updateBrand = async (data) => {
    try {
        const res = await api.put(`/update-brand`, data);
        return res.data;
    } catch (error) {
        console.error("Error updating brand:", error);
        throw error;
    }
};

export const deleteBrand = async (id) => {
    try {
        const res = await api.delete(`/delete-brand?id=${id}`);
        return res.data;
    } catch (error) {
        console.error("Error deleting brand:", error);
        throw error;
    }
};